import { render } from "./Tab1.vue?vue&type=template&id=2b2feacc&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=ts"
export * from "./Tab1.vue?vue&type=script&lang=ts"

import "./Tab1.vue?vue&type=style&index=0&id=2b2feacc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b2feacc"

export default script